function readCompactXmlText(node: unknown): string {
  if (typeof node === 'string' || typeof node === 'number') return String(node)
  if (!node || typeof node !== 'object') return ''
  const record = node as Record<string, unknown>
  const chunks: unknown[] = []
  if (Array.isArray(record._cdata)) chunks.push(...record._cdata)
  else if (record._cdata != null) chunks.push(record._cdata)
  if (Array.isArray(record._text)) chunks.push(...record._text)
  else if (record._text != null) chunks.push(record._text)
  return chunks.map((part) => String(part ?? '')).join('')
}

function presentHtmlFieldValue(raw: unknown): string {
  if (typeof raw === 'string') return raw
  if (typeof raw === 'number' || typeof raw === 'boolean') return String(raw)
  return ''
}

/**
 * Empty `type=HTML` shows metadata `<text>` (static markup). A non-empty page value wins.
 * The fallback is display-only: getInitialValue does not copy it into page data.
 */
export function resolveStaticHtmlElementValue(rawValue: unknown, element: unknown): string {
  const fromField = presentHtmlFieldValue(rawValue)
  if (fromField.trim()) return fromField
  const staticText = readCompactXmlText(
    element && typeof element === 'object' ? (element as { text?: unknown }).text : undefined,
  )
  return staticText.trim() ? staticText : fromField
}
